export { default as CuratedCategory } from "./CuratedCategory";
